let port = window.location.port
let dict_url = {
  '12301': 'http://127.0.0.1:10000', //本地
  '11101': 'http://47.94.88.15:21101', //北京
  '11301': 'http://47.112.120.187:21301', //河北
  '11501': 'http://39.108.61.54:21501', //内蒙
  '13201': 'http://120.77.45.95:23201', //江苏
  '14101': 'http://120.76.251.32:24101', //河南
  '14401': 'http://120.78.213.53:24401', //广东
  '80': 'http://127.0.0.1:24401', //线下
  '11601': 'http://120.77.45.95:21601', //综合
}
const baseURL = dict_url[port]
// const baseURL = dict_url['12301']

export default baseURL
